import {addI18Keysets} from '../../../i18n/index';

import dicts from './dicts';

export default addI18Keysets('yt:operation-pool', dicts);
